import Api from './Api'
import { createQueryString } from "./ApiHelper";

export default {
    GetFnBList(payload) {
        return Api().post('/pos/admin/getfnbitems', payload)
    },
    GetFnbCheckVendorRates(payload) {
        return Api().post("/pos/admin/getMissingVendorRatesItem", payload);
      },
    GetFnBCategories(payload) {
        const query = createQueryString(payload);
        console.log('query GetFnBCategories', query);
        return Api().get(`/pos/admin/getfnbcategories${query}`)
    },
    GetFnBSubCategories(payload) {
        return Api().get(`/pos/admin/getfnbsubcategories/${payload.parentid}`)
    },
    CallCheckout(payload) {
        return Api().post(`/pos/admin/checkout`, payload)
    },
    GetFnBAdditionalCharges(payload) {
        return Api().get(`/pos/admin/getfnbaddtionalprice/${payload.item_id}`)
    },
    OnFinalOrderSubmit(payload) {
        return Api().post(`/pos/admin/fnbtransaction`, payload)
    },
    OnAddRawMaterialIntoStore(payload) {
        return Api().post('/pos/admin/addrawmaterialintostore', payload)
    },
    OnSaveFnBPhoneNumber(payload) {
        return Api().put('/pos/admin/fnbsavephonenumber', payload)
    },
    OnChangeFnBPaymnetStatus(payload) {
        return Api().put('/pos/admin/fnbsetpaymentstatus', payload)
    },
    GetPosFnbFooterMenus(){
        return Api().get('/pos/admin/posfnbfootermenus')
    },
    GetFnbAlternateItems(payload){
        return Api().get(`/pos/admin/alternateitems/${payload.item_id}`)
    }
}


// WEBPACK FOOTER //
// ./src/services/Pos_Fnb_Service.js